// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { post, put } from '../../../../common/api'
import { ADD_EMPLOYEE, CHANGE_PASSWORD, EDIT_EMPLOYEE, EMPLOYEE, EMPLOYEE_DETAILS, EMPLOYEE_LIST, GET_EMPLOYEE } from '../../../../common/constant'

export const actionAddEmployee = createAsyncThunk('appEmployee/actionAddEmployee', async (params, thunkAPI) => {
    return await put(ADD_EMPLOYEE, params, thunkAPI)
})

export const actionEditEmployee = createAsyncThunk('appCluster/actionEditEmployee', async (params, thunkAPI) => {
    return await post(EDIT_EMPLOYEE, params, thunkAPI)
})

export const actionEmployee = createAsyncThunk('appEmployee/actionEmployee', async (params, thunkAPI) => {
    return await post(EMPLOYEE, params, thunkAPI)
})

export const actionGetEmployee = createAsyncThunk('appEmployee/actionGetEmployee', async (params, thunkAPI) => {
    return await post(GET_EMPLOYEE, params, thunkAPI)
})

export const actionEmployeeDetails = createAsyncThunk('appEmployee/actionEmployeeDetails', async (params, thunkAPI) => {
    return await post(EMPLOYEE_DETAILS, params, thunkAPI)
})

export const actionEmployeeList = createAsyncThunk('appEmployee/actionEmployeeList', async (params, thunkAPI) => {
    return await post(EMPLOYEE_LIST, params, thunkAPI)
})

export const actionChangePassword = createAsyncThunk('appEmployee/actionChangePassword', async (params, thunkAPI) => {
    return await post(CHANGE_PASSWORD, params, thunkAPI)
})

export const appEmployeeSlice = createSlice({
    name: 'appEmployee',
    initialState: {
        //add
        loadingAdd: false,
        addEmployee: null,

        //edit
        loadingEdit: false,
        editEmployee: null,

        //list
        loading: false,
        employee: null,

        //get
        loadingGet: false,
        getEmployee: null,

        //view
        loadingDetails: false,
        employeeDetails: null,

        //employee-list
        loadingList: false,
        employeeList: null,

        //change password
        loadingPassword: false,
        changePassword: null

    },
    reducers: {
        //reset or delete Add Employee store data
        resetAddEmployeeResponse: (state) => {
            state.addEmployee = null
        },
        resetEmployeeResponse: (state) => {
            state.employee = null
        },
        resetEditEmployeeResponse: (state) => {
            state.editEmployee = null
        },
        resetGetEmployeeResponse: (state) => {
            state.getEmployee = null
        },
        resetEmployeeDetailsResponse: (state) => {
            state.employeeDetails = null
        },
        resetEmployeeListResponse: (state) => {
            state.employeeList = null
        },
        resetChangePasswordResponse: (state) => {
            state.changePassword = null
        }

    },
    extraReducers: builder => {
        builder

            //add
            .addCase(actionAddEmployee.pending, (state) => {
                state.loadingAdd = true
            })
            .addCase(actionAddEmployee.fulfilled, (state, action) => {
                state.loadingAdd = false
                state.addEmployee = action.payload
            })
            .addCase(actionAddEmployee.rejected, (state) => {
                state.loading = false
            })

            //list
            .addCase(actionEmployee.pending, (state) => {
                state.loading = true
            })
            .addCase(actionEmployee.fulfilled, (state, action) => {
                state.loading = false
                state.employee = action.payload
            })
            .addCase(actionEmployee.rejected, (state) => {
                state.loading = false
            })

            //edit
            .addCase(actionEditEmployee.pending, (state) => {
                state.loadingEdit = true
            })
            .addCase(actionEditEmployee.fulfilled, (state, action) => {
                state.loadingEdit = false
                state.editEmployee = action.payload
            })
            .addCase(actionEditEmployee.rejected, (state) => {
                state.loading = false
            })

            //get
            .addCase(actionGetEmployee.pending, (state) => {
                state.loadingGet = true
            })
            .addCase(actionGetEmployee.fulfilled, (state, action) => {
                state.loadingGet = false
                state.getEmployee = action.payload
            })
            .addCase(actionGetEmployee.rejected, (state) => {
                state.loadingGet = false
            })

            //view
            .addCase(actionEmployeeDetails.pending, (state) => {
                state.loadingDetails = true
            })
            .addCase(actionEmployeeDetails.fulfilled, (state, action) => {
                state.loadingDetails = false
                state.employeeDetails = action.payload
            })
            .addCase(actionEmployeeDetails.rejected, (state) => {
                state.loadingDetails = false
            })

            //employee-list
            .addCase(actionEmployeeList.pending, (state) => {
                state.loadingList = true
            })
            .addCase(actionEmployeeList.fulfilled, (state, action) => {
                state.loadingList = false
                state.employeeList = action.payload
            })
            .addCase(actionEmployeeList.rejected, (state) => {
                state.loadingList = false
            })

            //changePassword
            .addCase(actionChangePassword.pending, (state) => {
                state.loadingPassword = true
            })
            .addCase(actionChangePassword.fulfilled, (state, action) => {
                state.loadingPassword = false
                state.changePassword = action.payload
            })
            .addCase(actionChangePassword.rejected, (state) => {
                state.loading = false
            })

    }
})
export const { resetAddEmployeeResponse, resetEmployeeResponse, resetEditEmployeeResponse, resetGetEmployeeResponse, resetEmployeeDetailsResponse, resetEmployeeListResponse, resetChangePasswordResponse } = appEmployeeSlice.actions

export default appEmployeeSlice.reducer